import { render, staticRenderFns } from "./ExistingSpousalSupportOrderAgreement.vue?vue&type=template&id=41f204d5"
import script from "./ExistingSpousalSupportOrderAgreement.vue?vue&type=script&lang=ts"
export * from "./ExistingSpousalSupportOrderAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports